.dialog {
    animation: animateDialog 0.5s;
    border: none;
    border-radius: 0.25rem;
    margin-top: 3vh;
    min-width: 100vw;
    overflow: hidden;
    padding: 0;
}

.dialog::backdrop {
    background-color: hsla(216, 39%, 15%, 0.75);
}

@media (min-width: 32rem) {
    .dialog {
        min-width: 32rem;
        width: 32rem;
    }
}

@keyframes animateDialog {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
